import { GetTrendsParams } from "../../app/api/trends";
import {
  materialsForBackend,
  stylingDetailsForBackend,
} from "../../constants/constants";
import { TrendInterface } from "../../interface/Trends";

export type LiveTrendsCache = {
  cacheKey: string;
  reqId: string;
  page: number;
  trends: TrendInterface[];
  trendCount: number;
};

const TREND_FEATURE_SESSION_KEYS = [
  ...Object.keys(materialsForBackend),
  ...Object.keys(stylingDetailsForBackend),
];

let liveTrendsCache: LiveTrendsCache | null = null;

export const getTrendSessionCacheKey = (filters: GetTrendsParams): string => {
  const selectedFeatures = TREND_FEATURE_SESSION_KEYS.filter(key =>
    Boolean(filters[key as keyof GetTrendsParams])
  )
    .sort()
    .join(",");

  return [
    filters.req_id ?? "",
    selectedFeatures,
    filters.apparel_type ?? "",
    filters.query_type ?? "",
    String(filters.page ?? 1),
    filters.brands ?? "",
    filters.start_date ?? "",
    filters.end_date ?? "",
    filters.color_analysis_level ?? "",
    filters.selected_color ?? "",
    filters.category ?? "",
    filters.gender ?? "",
    filters.genre ?? "",
    filters.source ?? "",
    filters.region ?? "",
    filters.age_group ?? "",
    filters.product ?? "",
    filters.colors ?? "",
  ].join("|");
};

export const saveLiveTrendsCache = (entry: LiveTrendsCache) => {
  liveTrendsCache = entry;
};

export const readLiveTrendsCache = (
  filters: GetTrendsParams
): LiveTrendsCache | null => {
  if (!liveTrendsCache) return null;
  if (liveTrendsCache.cacheKey !== getTrendSessionCacheKey(filters)) {
    return null;
  }
  return liveTrendsCache;
};

export const invalidateLiveTrendsCache = () => {
  liveTrendsCache = null;
};
